import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  SearchFilterOptionsResultApiModel,
  SearchFormsResponseApiModel,
  SearchRequestApiModel
} from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class SearchService {
  public apiUrl = 'search';

  constructor(private readonly http: HttpClientService) {}

  public getFilterOptions(searchQuery: any): Observable<SearchFilterOptionsResultApiModel> {
    return this.http.get<SearchFilterOptionsResultApiModel>(`${this.apiUrl}/filter-options`, { params: searchQuery });
  }

  public getForms(searchQuery: any): Observable<SearchFormsResponseApiModel> {
    return this.http.get<SearchFormsResponseApiModel>(`${this.apiUrl}/search`, { params: searchQuery });
  }

  public getXlsx(model: SearchRequestApiModel): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/xlsx`, model, { responseType: 'blob' });
  }
}
